<template>
    <vs-card>
        <form-wizard
            shape="square"
            class="cstm_form_wizard cstm_builder_wizard"
            title=""
            subtitle=""
            stepSize="xs"
            color="rgb(var(--vs-primary))"
            ref="wizard"
            >
            <!-- Tab 1 -->
            <tab-content title="Course Selection" @click="nextTab">
                <CourseSelection :clear="clear" :course_id="course_id" @selectedCourse="selectedCourse"  />
            </tab-content>
            <!-- Tab 2 -->
            <tab-content title="Add/Select Student">
                <AddSelectStudent :clear="clear" @selectedStudent="selectedStudent" />
            </tab-content>
            <!-- Tab 3 -->
            <tab-content title="Course Scheduling" >
                <CourseScheduling :selected_course_id="selected_course_id" :counter="counter" :courseDetails="courseDetails" @scheduled="scheduled" />
            </tab-content>
            <!-- Tab 4 -->
            <tab-content title="Confirmation">
                <Confirmation :viewscheduleData="viewscheduleData" :counter="counter" :courseDetails="courseDetails" :confirmModalData="confirmModalData" />
            </tab-content>

            <template slot="footer" slot-scope="props">
              <div class="wizard-footer-left">
                <vs-button v-if="props.activeTabIndex == 1 && !props.isLastStep" @click.native="props.prevTab()">Previous</vs-button>
              </div>
              <div class="wizard-footer-right">
                <vs-button v-if="props.isLastStep" @click="confirmDetails">Confirm Enrollment</vs-button>
                <vs-button v-else @click.native="nextTab(props.activeTabIndex)" :disabled="(props.activeTabIndex == 1 && !selected_student_id) || (props.activeTabIndex==2 && !viewscheduleData)">Next</vs-button>
              </div>
            </template>
        </form-wizard>
    </vs-card>
</template>

<script>
import { FormWizard, TabContent, WizardButton } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import CourseSelection from './components/CourseSelection.vue'
import AddSelectStudent from './components/AddSelectStudent.vue'
import CourseScheduling from './components/CourseScheduling.vue'
import Confirmation from './components/Confirmation.vue'

import { finalEnroll, getFixedSchedules } from '@/api/enrollment.js'

export default {
  props: {
    course_id:{default:null},
    detailsCourse:{default:null},
    clearWizard:{
      default: false
    }
  },
  data () {
    return {
      selected_course_id:null,
      teacher_id:null,
      selected_student_id:null,
      counter:0,
      courseDetails:null,
      viewscheduleData:null,
      confirmModalData:null,
      clear:false

    }
  },
  components: {
    FormWizard,
    TabContent,
    WizardButton,
    CourseSelection,
    AddSelectStudent,
    CourseScheduling,
    Confirmation
  },
  watch: {
    clearWizard () {
      this.$refs.wizard.reset()
    }
  },
  mounted () {
    console.log(this.course_id, this.detailsCourse)
    if (this.course_id, this.detailsCourse) {
      this.selected_course_id = this.course_id
      this.courseDetails = this.detailsCourse
    }

  },
  methods: {
    async confirmDetails () {
      try {
        const { data } = await finalEnroll(localStorage.getItem('customer_id'), this.courseDetails.id, this.confirmModalData)
        this.$emit('enrollmentComplete', data)
        this.$vs.notify({
          title: 'Success',
          text: 'Course enrollment successfully completed',
          ...this.successProp()
        })
        this.$refs.wizard.reset()
        this.selected_course_id = null
        this.selected_student_id = null

        this.clear = true
      } catch (e) {
        this.$vs.notify({
          title: 'Error',
          text: e.data.message,
          ...this.warnProp()
        })
      }

    },
    async scheduled (data, slots, teacher_id) {
      console.log(data, slots, teacher_id)
      this.teacher_id = teacher_id
      this.viewscheduleData = Object.assign({}, data)
      this.confirmModalData = Object.assign({}, {schedules:data}, slots, {client_user_id:this.selected_student_id})
    },
    async selectedCourse (course_id, course_details) {
      this.selected_course_id = course_id
      this.courseDetails = course_details
    },
    async selectedStudent (student_id) {
      this.selected_student_id = student_id

    },
    async nextTab (activeTabIndex) {
      if (!this.selected_course_id) {
        return  this.$vs.notify({
          title: 'Warning',
          text: 'Please select a course first',
          ...this.warnProp()
        })
      }
      if (activeTabIndex === 1) {
        if (['offline_one_2_many', 'online_one_2_many'].includes(this.courseDetails.course_class_type)) {
          const { data } = await getFixedSchedules(localStorage.getItem('customer_id'), this.courseDetails.id)
          this.viewscheduleData = Object.assign({}, data.data)
          this.confirmModalData = Object.assign({}, {schedules:data}, {client_user_id:this.selected_student_id})
          this.$refs.wizard.nextTab()
          this.$refs.wizard.nextTab()
        } else if (['self_based'].includes(this.courseDetails.course_class_type)) {
          this.confirmModalData = Object.assign({}, {client_user_id:this.selected_student_id})
          this.$refs.wizard.nextTab()
          this.$refs.wizard.nextTab()
        }  else {
          this.$refs.wizard.nextTab()
        }
      } else {
        this.$refs.wizard.nextTab()
      }

      this.counter++

    }
  }
}
</script>
